export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.enterprise-overview': 'Enterprise Overview',
  'menu.application-management': 'Application Management',
  'menu.organization-structure': 'Organization Structure',
  'menu.organization-structure.members-and-departments':
    'Members & Departments',
  'menu.organization-structure.invite-member': 'Invite Member',
  'menu.organization-structure.member-applications': 'Member Applications',
  'menu.organization-structure.position-management': 'Position Management',
  'menu.invite-member': 'Invite Member',
  'menu.member-applications': 'Member Applications',
  'menu.cost-center': 'Cost Center',
  'menu.cost-center.my-subscription': 'My Subscription',
  'menu.cost-center.purchase-catalog': 'Purchase Catalog',
  'menu.cost-center.entitlements-upgrade': 'Upgrade Entitlements',
  'menu.cost-center.my-products': 'My Products',
  'menu.cost-center.seat-allocation': 'Seat Allocation',
  'menu.cost-center.entitlements': 'Entitlement Data',
  'menu.cost-center.orders': 'Order List',
  'menu.cost-center.invoices': 'Invoice Management',
  'menu.ai-usage': 'AI Usage Management',
  'menu.ai-usage.usage-overview': 'Usage Overview',
  'menu.ai-usage.usage-details': 'Usage Details',
  'menu.ai-usage.usage-logs': 'Usage Logs',
  'menu.ai-usage.quota-management': 'Quota Management',
  'menu.ai-usage.storage-space': 'Storage Space',
  'menu.ai-usage.storage-space.capacity-overview': 'Capacity Overview',
  'menu.ai-usage.storage-space.storage-cleanup': 'Storage Cleanup',
  'menu.ai-usage.storage-space.limit-management': 'Upper Limit Management',
  'menu.enterprise-culture': 'Enterprise Culture',
  'menu.enterprise-culture.brand-config': 'Brand Configuration',
  'menu.enterprise-settings': 'Enterprise Settings',
  'menu.enterprise-settings.enterprise-info': 'Enterprise Information',
  'menu.enterprise-settings.admin-permissions': 'Admin Permissions',
  'menu.bot-management': 'Bot Management',
  'menu.receive-management': 'Receive Management',
  'menu.receive-management.receive-config': 'Basic Receive Config',
  'menu.receive-management.bot-config': 'Bot Receive Config',
  'menu.receive-management.category-management': 'Category Management',
  'menu.receive-management.bot-management': 'Bot Management',
  'menu.receive-management.channel-config': 'Channel Config',
  'menu.channel-config': 'Channel Config',
  'menu.roles-and-permissions': 'Roles & Permissions',
  'menu.roles-and-permissions.permission-management': 'Permission Management',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
